import localeModule from 'timeago.js/lib/lang/nl'
const localeName = 'nl'
export default { locale: localeName, module: localeModule }
